import {
    DTOCardFormField,
    NestedField,
} from 'app/types/form.types'
import {
    LeaseType, TransportModeRoad, Selection, OrderTransportModeRoad, DeliveryOptionRoad,
} from 'app/enums/label.enums'
import {
    Lane,
} from 'app/Apps/OrderManagement/Lanes/lanes.types'

import {
    FinalizeBookingStepType,
} from '../../createCustomerTransportForm.types'

const getFields = ({
    originScSelection,
    isDeliveryRoad,
    laneData,
    getAllowedValues,
    originScBackup,
    fwdPosBackup,
    disabled,
    deliveryOptionRoad,
    transportModeForwarder,
}: {
    getAllowedValues: (enumType: any) => Record<string, string>,
    originScSelection: Selection,
    isDeliveryRoad: boolean,
    laneData: Lane,
    originScBackup: {id: number},
    fwdPosBackup: {id: number},
    disabled: boolean,
    deliveryOptionRoad: DeliveryOptionRoad,
    transportModeForwarder: TransportModeRoad,
}): DTOCardFormField<keyof FinalizeBookingStepType>[] => {
    return [{
        title: 'Booking Details',
        className: 'bookingDetails',
        id: 'bookingDetails',
        fields: [
            {
                id: 'bookingDetails-column1',
                fields: [
                    ...isDeliveryRoad ? [{
                        name: 'transportModeRoad',
                        componentName: 'EnumSelector',
                        allowedValues: getAllowedValues(OrderTransportModeRoad),
                        disabled: disabled || (laneData.transportModeRoad === TransportModeRoad.LTL
                            || laneData.transportModeRoad === TransportModeRoad.FTL),
                        labelKey: 'Order.transportModeRoad',
                    }] as NestedField<keyof FinalizeBookingStepType>[] : [],
                    ...isDeliveryRoad ? [{
                        name: 'transportModeForwarder',
                        componentName: 'EnumSelector',
                        allowedValues: getAllowedValues(OrderTransportModeRoad),
                        required: true,
                        labelKey: 'Order.transportModeForwarder',
                    }] as NestedField<keyof FinalizeBookingStepType>[] : [],
                    ...transportModeForwarder === TransportModeRoad.FTL ? [{
                        name: 'deliveryOptionRoad',
                        componentName: 'EnumSelector',
                        allowedValues: getAllowedValues(DeliveryOptionRoad),
                        required: true,
                        className: 'deliveryOptionRoad',
                        labelKey: 'OrderStep.deliveryOptionRoad',
                    }] as NestedField<keyof FinalizeBookingStepType>[] : [],
                    ...deliveryOptionRoad === DeliveryOptionRoad.TRUCKS ? [{
                        name: 'numberOfTrucks',
                        componentName: 'IntegerInput',
                        className: 'numberOfVehicles',
                        required: true,
                        labelKey: 'OrderStep.numberOfTrucks',
                    }] as NestedField<keyof FinalizeBookingStepType>[] : [],
                    ...deliveryOptionRoad === DeliveryOptionRoad.VANS ? [{
                        name: 'numberOfVans',
                        componentName: 'IntegerInput',
                        className: 'numberOfVehicles',
                        required: true,
                        labelKey: 'OrderStep.numberOfVans',
                    }] as NestedField<keyof FinalizeBookingStepType>[] : [],
                    {
                        name: 'orderEntered',
                        componentName: 'DateTimeZonedSelect',
                        disabled: true,
                        labelKey: 'Order.orderEntered',
                    },
                    {
                        name: 'mawbNumber',
                        componentName: 'InputSingleline',
                        labelKey: 'Order.mawbNumber',
                    },
                ],
            },
            {
                id: 'bookingDetails-column2',
                fields: [
                    ...originScBackup ? [{
                        name: 'originScSelection',
                        componentName: 'EnumSelector',
                        allowedValues: getAllowedValues(Selection),
                        noSort: true,
                        labelKey: 'CustomerTransportCreateDto.originScSelection',
                    }] as NestedField<keyof FinalizeBookingStepType>[] : [],
                    ...originScSelection === Selection.BACKUP
                        ? [{
                            name: 'originScBackup',
                            componentName: 'LocationObjectSelector',
                            disabled: true,
                            labelKey: 'Lane.originSc',
                        }] as NestedField<keyof FinalizeBookingStepType>[]
                        : [{
                            name: 'originSc',
                            componentName: 'LocationObjectSelector',
                            disabled: true,
                            labelKey: 'Lane.originSc',
                        }] as NestedField<keyof FinalizeBookingStepType>[],
                    {
                        name: 'hawbNumber',
                        componentName: 'InputSingleline',
                        labelKey: 'CustomerTransportCreateDto.hawbNumber',
                    },
                    ...isDeliveryRoad ? [{
                        name: 'estimatedPickup',
                        componentName: 'DateTimeZonedSelect',
                        labelKey: 'CustomerTransportCreateDto.estimatedPickup',
                    }] as NestedField<keyof FinalizeBookingStepType>[] : [],
                ],
            },
            {
                id: 'bookingDetails-column3',
                fields: [
                    ...fwdPosBackup ? [{
                        name: 'fwdPosSelection',
                        componentName: 'EnumSelector',
                        allowedValues: getAllowedValues(Selection),
                        noSort: true,
                        labelKey: 'CustomerTransportCreateDto.fwdPosSelection',
                    }] as NestedField<keyof FinalizeBookingStepType>[] : [],
                    {
                        name: 'commentForBillingOps',
                        componentName: 'LongText',
                        labelKey: 'OrderByNumberView.commentForBillingOps',
                    },
                    {
                        name: 'personInCharge',
                        componentName: 'InputSingleline',
                        labelKey: 'Order.personInCharge',
                    },
                    ...laneData?.leaseType === LeaseType.AIRLINE_LEASE ? [{
                        name: 'freightForwarder',
                        componentName: 'CompanyObjectSelector',
                        labelKey: 'OrderByNumberView.freightForwarder',
                    }] as NestedField<keyof FinalizeBookingStepType>[] : [],
                ],
            },

            {
                id: 'bookingDetails-column4',
                fields: [
                    {
                        name: 'minOrder',
                        value: laneData?.minOrder,
                        componentName: 'InputSingleline',
                        disabled: true,
                        labelKey: 'LaneOpsInformationDto.minOrder',
                    },
                    {
                        name: 'requiredCargoComment',
                        componentName: 'LongText',
                        labelKey: 'Order.requiredCargoComment',
                    },
                ],
            },
        ],
    }]
}

export default getFields
